import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { TablePagination } from '@lumahealthhq/ui-core';
import { useIntl } from '../../../hooks';
import { useDataResourceContext } from '../../contexts/DataResourceContext';
import { usePaginationContext } from '../../contexts/PaginationContext';
import { ActionsComponent } from './components';

/**
 * @ignore - internal component.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default function TablePaginationFooter() {
  const intl = useIntl();
  const {
    getPaginationProps
  } = usePaginationContext();
  const {
    totalSize,
    isLoading
  } = useDataResourceContext();
  const paginationProps = React.useMemo(() => getPaginationProps(totalSize, isLoading), [totalSize, isLoading, getPaginationProps]);
  return /*#__PURE__*/_jsx(TablePagination
  // eslint-disable-next-line react/no-unstable-nested-components
  , _extends({
    ActionsComponent: props => /*#__PURE__*/_jsx(ActionsComponent, _extends({}, props)),
    labelDisplayedRows: ({
      count
    }) => intl.formatMessage({
      id: "l70O4a",
      defaultMessage: [{
        "type": 6,
        "value": "count",
        "options": {
          "one": {
            "value": [{
              "type": 7
            }, {
              "type": 0,
              "value": " Result"
            }]
          },
          "other": {
            "value": [{
              "type": 7
            }, {
              "type": 0,
              "value": " Results"
            }]
          }
        },
        "offset": 0,
        "pluralType": "cardinal"
      }]
    }, {
      count
    }),
    sx: theme => ({
      paddingInline: `${theme.spacing(1.5)} !important`,
      flexShrink: 0,
      '& .MuiTablePagination-toolbar': {
        paddingLeft: 0
      },
      '& > div': {
        '& > div:first-of-type': {
          flex: 0
        },
        '& > p.MuiTablePagination-displayedRows': {
          flexGrow: 1,
          textAlign: 'center',
          color: theme.palette.text.secondary
        }
      }
    })
  }, paginationProps));
}